var checklist = "https://shopfront-cdn.tekoapis.com/static/58a618ad98de3016.svg";

export { checklist as default };
